module.exports = __webpack_public_path__ + "static/media/thinRed.a70c8150.svg";